import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import {showHacetteUpdated} from '../settingsSlice';

export const useSetShowHachette = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (showHachette: boolean) => {
      dispatch(showHacetteUpdated(showHachette));
    },
    [dispatch],
  );
};
